{
  "title": "Gold for Emilian in Barcelona",
  "date": "2026-08-02T21:01:00+02:00",
  "category": "Competition",
  "excerpt": "Our young athlete Emilian wins gold in his division at the FIJJD International Championship 2026 in Barcelona.",
  "body": "Our young athlete Emilian claimed gold in his division at the FIJJD International Championship 2026 in Barcelona. Guided by Coach Tiago, he delivered a focused and determined performance in a thrilling contest and earned his place at the top of the podium.\n\nThe entire Tiago de Paula BJJ team is incredibly proud of Emilian and this outstanding achievement. Congratulations, champion — your hard work, courage and dedication have paid off. Oss!",
  "image": "/images/emilian-gold-barcelona.svg",
  "featured": true
}
